export default {
    methods: {
        customUsersFilter(user, queryText) {
            const fullName = `${user.firstName} ${user.lastName}`

            const userName = fullName.replace(/\s/g, '').length > 0 ? fullName : user.username,
                search = queryText.toLowerCase()

            return userName.toLowerCase().indexOf(search) > -1
        },
        customFilter(item, queryText) {
            const name = item.name.toLowerCase(),
                search = queryText.toLowerCase()

            return name.indexOf(search) > -1
        }
    }
}
